import * as React from 'react';
import { Button, Form, Message } from 'semantic-ui-react';

interface Asignaturas {
    lenguaje: boolean;
    matematica: boolean;
    historia: boolean;
    cienciasCH: boolean;
    cienciasTec: boolean;
}

type Electivo = 'ninguno' | 'biologia' | 'fisica' | 'quimica';

interface Sugerencia {
    texto: string;
    obtenerAsignaturas(): { asignaturas: Asignaturas; electivo: Electivo };
}

const sugerencias: Sugerencia[] = [
    {
        texto: 'Len + Mat + His',
        obtenerAsignaturas: () => ({
            asignaturas: {
                lenguaje: true,
                matematica: true,
                historia: true,
                cienciasCH: false,
                cienciasTec: false,
            },
            electivo: 'ninguno',
        }),
    },

    {
        texto: 'Len + Mat + Cie(CH)',
        obtenerAsignaturas: () => ({
            asignaturas: {
                lenguaje: true,
                matematica: true,
                historia: false,
                cienciasCH: true,
                cienciasTec: false,
            },
            electivo: 'biologia',
        }),
    },

    {
        texto: 'Len + Mat + Cie(Tec)',
        obtenerAsignaturas: () => ({
            asignaturas: {
                lenguaje: true,
                matematica: true,
                historia: false,
                cienciasCH: false,
                cienciasTec: true,
            },
            electivo: 'ninguno',
        }),
    },

    {
        texto: 'Len + Mat',
        obtenerAsignaturas: () => ({
            asignaturas: {
                lenguaje: true,
                matematica: true,
                historia: false,
                cienciasCH: false,
                cienciasTec: false,
            },
            electivo: 'ninguno',
        }),
    },

    {
        texto: 'Mat + Cie(CH)',
        obtenerAsignaturas: () => ({
            asignaturas: {
                lenguaje: false,
                matematica: true,
                historia: false,
                cienciasCH: true,
                cienciasTec: false,
            },
            electivo: 'biologia',
        }),
    },
];

export interface Datos {
    asignaturas: Asignaturas;
    electivo: Electivo;
    modalidad?: 'presencial' | 'online';
    jornada?: 'mañana' | 'tarde' | 'vespertino';
}

export const inicial: Datos = {
    asignaturas: {
        lenguaje: false,
        matematica: false,
        historia: false,
        cienciasCH: false,
        cienciasTec: false,
    },
    electivo: 'ninguno',
    modalidad: 'presencial',
    jornada: 'mañana',
};

const asignaturaCheckboxStyle = { marginBottom: '1ex' };

interface Props {
    datos: Datos;
    onChange(datos: Datos): void;
}

class DatosMatriculaPreu extends React.Component<Props> {
    private readonly sugerenciasButtons = sugerencias.map((item, index) => (
        <Button
            key={index}
            type='button'
            onClick={() => {
                this.onChange({ ...this.props.datos, ...item.obtenerAsignaturas() });
            }}
        >
            {item.texto}
        </Button>
    ));

    public render() {
        const { datos } = this.props;

        return (
            <>
                <Form.Group widths='3'>
                    <Form.Field>
                        <label>Modalidad</label>
                        <Form.Radio
                            label='Presencial'
                            checked={datos.modalidad === 'presencial'}
                            onChange={() => {
                                this.onChange({ ...datos, modalidad: 'presencial' });
                            }}
                        />
                        <Form.Radio
                            label='Online'
                            checked={datos.modalidad === 'online'}
                            onChange={() => {
                                this.onChange({ ...datos, modalidad: 'online' });
                            }}
                        />

                        {!datos.modalidad && (
                            <Message color='red'>
                                No se seleccionó una modalidad para esta matrícula.
                            </Message>
                        )}
                    </Form.Field>

                    <Form.Field>
                        <label>Jornada</label>
                        <Form.Radio
                            label='Mañana (1h30m / bloque)'
                            checked={datos.jornada === 'mañana'}
                            onChange={() => {
                                this.onChange({ ...datos, jornada: 'mañana' });
                            }}
                        />
                        <Form.Radio
                            label='Tarde (1h30m / bloque)'
                            checked={datos.jornada === 'tarde'}
                            onChange={() => {
                                this.onChange({ ...datos, jornada: 'tarde' });
                            }}
                        />
                        <Form.Radio
                            label={`Vespertino (${
                                datos.modalidad === 'online' ? '1h30m' : '1h15m'
                            } / bloque)`}
                            checked={datos.jornada === 'vespertino'}
                            onChange={() => {
                                this.onChange({ ...datos, jornada: 'vespertino' });
                            }}
                        />
                    </Form.Field>

                    {!datos.jornada && (
                        <Message color='red'>
                            No se seleccionó una jornada para esta matrícula.
                        </Message>
                    )}
                </Form.Group>

                <Form.Group widths='3'>
                    <Form.Field>
                        <label>Sugerencias</label>
                        <Button.Group vertical>{this.sugerenciasButtons}</Button.Group>
                    </Form.Field>

                    <Form.Field>
                        <label>Asignaturas</label>
                        <Form.Checkbox
                            label='Lenguaje'
                            checked={datos.asignaturas.lenguaje}
                            onChange={(_e, { checked }) => {
                                this.onChange({
                                    ...datos,
                                    asignaturas: {
                                        ...datos.asignaturas,
                                        lenguaje: checked || false,
                                    },
                                });
                            }}
                            style={asignaturaCheckboxStyle}
                        />
                        <Form.Checkbox
                            label='Matemática'
                            checked={datos.asignaturas.matematica}
                            onChange={(_e, { checked }) => {
                                this.onChange({
                                    ...datos,
                                    asignaturas: {
                                        ...datos.asignaturas,
                                        matematica: checked || false,
                                    },
                                });
                            }}
                            style={asignaturaCheckboxStyle}
                        />
                        <Form.Checkbox
                            label='Historia'
                            checked={datos.asignaturas.historia}
                            onChange={(_e, { checked }) => {
                                this.onChange({
                                    ...datos,
                                    asignaturas: {
                                        ...datos.asignaturas,
                                        historia: checked || false,
                                    },
                                });
                            }}
                            style={asignaturaCheckboxStyle}
                        />
                        <Form.Checkbox
                            label='Ciencias (CH)'
                            checked={datos.asignaturas.cienciasCH}
                            onChange={(_e, { checked }) => {
                                this.onChange({
                                    ...datos,
                                    asignaturas: {
                                        ...datos.asignaturas,
                                        cienciasCH: checked || false,
                                        cienciasTec: checked
                                            ? false
                                            : datos.asignaturas.cienciasTec,
                                    },
                                    electivo: checked ? 'biologia' : datos.electivo,
                                });
                            }}
                            style={asignaturaCheckboxStyle}
                        />
                        <Form.Checkbox
                            label='Ciencias (Tec)'
                            checked={datos.asignaturas.cienciasTec}
                            onChange={(_e, { checked }) => {
                                this.onChange({
                                    ...datos,
                                    asignaturas: {
                                        ...datos.asignaturas,
                                        cienciasTec: checked || false,
                                        cienciasCH: checked ? false : datos.asignaturas.cienciasCH,
                                    },
                                    electivo: checked ? 'ninguno' : datos.electivo,
                                });
                            }}
                            style={asignaturaCheckboxStyle}
                        />
                    </Form.Field>

                    <Form.Field
                        hidden={!datos.asignaturas.cienciasCH && !datos.asignaturas.cienciasTec}
                    >
                        <label>Electivos</label>

                        {datos.asignaturas.cienciasTec ? (
                            <Form.Radio
                                label='Ninguno'
                                checked={datos.electivo === 'ninguno'}
                                onChange={() => {
                                    this.onChange({ ...datos, electivo: 'ninguno' });
                                }}
                            />
                        ) : null}

                        <Form.Radio
                            label='Biología'
                            checked={datos.electivo === 'biologia'}
                            onChange={() => {
                                this.onChange({ ...datos, electivo: 'biologia' });
                            }}
                        />
                        <Form.Radio
                            label='Física'
                            checked={datos.electivo === 'fisica'}
                            onChange={() => {
                                this.onChange({ ...datos, electivo: 'fisica' });
                            }}
                        />
                        <Form.Radio
                            label='Química'
                            checked={datos.electivo === 'quimica'}
                            onChange={() => {
                                this.onChange({ ...datos, electivo: 'quimica' });
                            }}
                        />
                    </Form.Field>
                </Form.Group>
            </>
        );
    }

    private onChange(datos: Datos) {
        this.props.onChange({
            ...datos,
        });
    }
}

export default DatosMatriculaPreu;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S3Alumnos/componentes/Alumno/componentes/DatosMatricula/componentes/DatosMatriculaPreu.tsx